<template>
    <div class="card totalCost">
        <div class="p-card-header">
            <p class="title bold">{{ $t("totalCost.title") }}</p>
        </div>
        <div class="p-card-content" v-if="!!monthlyCost.subscribes.length">
            <p class="subtitle">{{ $t("totalCost.monthlyPayments") }}</p>
            <div v-for="(subscribe, index) of monthlyCost.subscribes" :key="index">
                <p class="packageName semiBold">{{ subscribe.plan.title }}</p>
                <div class="cost-content">
                    <p>
                        {{ subscribe.plan.altTitle }}
                        <span class="cost" v-if="subscribe.plan.type == 'supsis'">
                            {{ ~~(subscribe.plan.price || 0) }} x ({{ subscribe.details.agentCount }})
                            {{ $t("totalCost.currency") }}
                        </span>
                        <span
                            class="cost"
                            v-else-if="subscribe.plan.type == 'whatsapp-business' || subscribe.plan.type == 'whatsapp'"
                        >
                            {{ ~~(subscribe.plan.price || 0) }} x ({{ subscribe.details.whatsappChannel }})
                            {{ $t("totalCost.currency") }}
                        </span>
                        <span class="cost" v-else>
                            {{ ~~(subscribe.price || 0) }} {{ $t("totalCost.currency") }}
                        </span>
                    </p>
                </div>
            </div>
            <div class="cost-total">
                <p class="cost bold">
                    {{ monthlyCost.total || 0 }}
                    {{ $t("totalCost.currencyMonthly") }}
                </p>
            </div>
        </div>
        <div class="p-card-content" v-if="!!annualCost.subscribes.length">
            <p class="subtitle">{{ $t("totalCost.oneTimePayments") }}</p>
            <div v-for="(subscribe, index) of annualCost.subscribes" :key="index">
                <a-row>
                    <a-col :span="11"
                        ><p class="packageName semiBold">{{ subscribe.plan.title }}</p></a-col
                    >
                </a-row>
                <a-row>
                    <div class="cost-content listcontent">
                        <p>
                            {{ subscribe.plan.altTitle }}
                            <span class="cost"
                                >{{ ~~(subscribe.price || 0) }} {{ $t("totalCost.currency") }}</span
                            >
                        </p>
                        <p v-if="subscribe.plan.price * 12 > subscribe.price">
                            {{ $t("totalCost.oneTimeDiscount") }}
                            <span class="cost discount-cost"
                                >-{{ ~~((subscribe.plan.price || 0) * 12 - (subscribe.price || 0)) }}₺</span
                            >
                        </p>
                    </div>
                </a-row>
            </div>
            <div class="cost-total">
                <p class="cost bold">{{ ~~(annualCost.total || 0) }} {{ $t("totalCost.currencyYearly") }}</p>
            </div>
        </div>
        <div class="p-card-footer">
            <a-row>
                <div class="total-cost-content listcontent">
                    <p>
                        {{ $t("totalCost.totalOneTimeCost") }}
                        <span class="cost bold"
                            >{{ ~~((annualCost.total || 0) + (monthlyCost.total || 0)) }} ₺</span
                        >
                    </p>
                    <p>
                        Vergi ( %{{ taxRate }} )
                        <span class="cost discount-cost bold"
                            >{{ ~~((((annualCost.total || 0) + (monthlyCost.total || 0)) * taxRate) / 100) }}
                            {{ $t("totalCost.currency") }}
                        </span>
                    </p>
                    <p>
                        Vergi Dahil Toplam
                        <span class="cost discount-cost bold"
                            >{{
                                ~~(
                                    (annualCost.total || 0) +
                                    (monthlyCost.total || 0) +
                                    (((annualCost.total || 0) + (monthlyCost.total || 0)) * taxRate) / 100
                                )
                            }}
                            {{ $t("totalCost.currency") }}
                        </span>
                    </p>
                </div>
            </a-row>
            <a-row>
                <p class="code-label">{{ $t("totalCost.referenceCode") }}</p>
                <div class="input-group discount-code mb-3">
                    <input
                        type="text"
                        class="form-control"
                        v-model="referenceCode"
                        :placeholder="$t('totalCost.referencePlaceholder')"
                    />
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button">
                            {{ $t("totalCost.codeButton") }}
                        </button>
                    </div>
                </div>
            </a-row>
        </div>
        <div class="footer">
            <a-row v-if="monthlyCost.total">
                <a-col class="cost-label" :span="17">{{ $t("totalCost.monthlyCost") }}</a-col>
                <a-col class="cost" :span="7">{{ ~~monthlyCost.total }}₺</a-col>
            </a-row>
            <a-row v-if="annualCost.total > 0">
                <a-col class="cost-label" :span="17">{{ $t("totalCost.oneTimeFullCost") }}</a-col>
                <a-col class="cost" :span="7">{{ ~~annualCost.total }}₺</a-col>
            </a-row>
        </div>
        <!-- <button class="card-footer btn btn-outline-secondary classic-border">Hemen Öde</button> Burası hemen ödeme sistemi gelince aktif olacak -->
        <button
            :disabled="disableComplateButton"
            class="card-footer btn btn-outline-secondary last-button"
            @click="complateWizard"
        >
            Devam Et
        </button>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import { mapState } from "vuex";

const log = log2("TotalCost");

export default {
    name: "TotalCost",
    props: {
        subscribes: {
            default: {},
        },
        disableComplateButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            site: (state) => state.site.site,
        }),
    },
    data() {
        const monthlyCost = {
            total: 0,
            subscribes: [],
        };
        const annualCost = {
            total: 0,
            subscribes: [],
        };
        for (const sub of Object.keys(this.subscribes).filter((sub) => this.subscribes[sub].plan)) {
            if (this.subscribes[sub].period == "monthly") {
                monthlyCost.total += this.subscribes[sub].price;
                monthlyCost.subscribes.push(this.subscribes[sub]);
            } else if (this.subscribes[sub].period == "annual") {
                annualCost.total += this.subscribes[sub].price;
                annualCost.subscribes.push(this.subscribes[sub]);
            }
        }
        return {
            referenceCode: null,
            monthlyCost,
            annualCost,
            taxRate: 20,
        };
    },
    methods: {
        complateWizard() {
            this.$emit("submit", this.referenceCode);
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
$base-color: #000000;
$second-color: #ec4b1d;

.card {
    border-radius: 20px;
    padding: 0 !important;
}

.totalCost {
    color: $base-color;
    font-family: Poppins;
    width: 495px;
    height: auto;

    .p-card-header {
        padding: 24px 24px 0 24px;

        .title {
            font-size: 30px;
        }
    }

    .p-card-content {
        padding: 0 24px;
    }

    .subtitle {
        font-size: 23px;
    }

    .packageName {
        margin-bottom: 0.5rem;
    }

    .cost-content {
        font-family: Quicksand;
        font-weight: 500;
        font-size: 12px;
        color: #7f7f7f;

        span {
            font-family: Poppins;
            color: $base-color;
        }

        &.listcontent {
            margin-bottom: 1rem;

            p {
                margin-bottom: 0.5rem;
            }
        }
    }

    .underline {
        text-decoration: underline;
        color: #92929d;
    }

    .active {
        color: $second-color;
    }

    .cost-total {
        color: $second-color;
        border-top: 1px solid #eeeeee;
    }

    p {
        &.cost {
            font-size: 15px;
            text-align: right;
            margin-top: 1rem;
        }

        span {
            &.cost {
                font-size: 15px;
                float: right;
            }
        }
    }

    .bold {
        font-weight: 700;
    }

    .semiBold {
        font-weight: 600;
    }

    .discount-cost {
        color: #6dd400 !important;
    }

    .p-card-footer {
        padding: 0 24px;

        .ant-row {
            margin-bottom: 1rem;
        }

        p {
            font-family: Quicksand;
            font-size: 15px;
            margin-bottom: 0.5rem;
        }

        .discount-code {
            input {
                border-color: #eeeeee;
                height: 50px;
            }

            button {
                width: 110px;
                background-color: $second-color;
                color: #ffffff;
                border-color: #eeeeee;
                font-weight: 600;
            }
        }

        .final-cost {
            background-color: #fafafa;
        }
    }

    .footer {
        padding: 24px 24px 0 24px;
        background-color: #00000008;
        font-size: 16px;
        font-weight: 600;
        text-align: end;

        .ant-row {
            padding-bottom: 1rem;
        }

        .cost-label {
            font-weight: 600;
        }

        .cost {
            font-size: 17px;
            padding-left: 5px;
            color: $second-color;
        }
    }

    .card-footer {
        border-color: #eeeeee00;
        border-radius: 0 0 20px 20px;
        background-color: $second-color;
        color: #ffffff;
        font-weight: 600;
        height: 50px;

        &.classic-border {
            border-radius: 0 !important;
        }

        &.last-button {
            margin-top: 1px;
        }
    }
}
</style>
